const stats = [
  { value: "12+", label: "Years Experience" },
  { value: "100%", label: "Client Success" },
  { value: "0", label: "Compromises on Quality" },
  { value: "9.1K+", label: "LinkedIn Followers" },
];

export function Stats() {
  return (
    <section className="border-y border-border bg-surface/50">
      <div className="mx-auto flex max-w-7xl flex-row justify-center gap-8 px-6 py-12 md:py-16">
        {stats.slice(0, 4).map((s) => (
          <div key={s.label} className="flex flex-col items-center text-center px-4">
            <div className="text-4xl font-bold text-gradient md:text-5xl">{s.value}</div>
            <div className="mt-2 text-sm font-medium uppercase tracking-wider text-muted-foreground">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
